import { useEffect, useState } from "react";
import "./previewBlog.scss";
import moment from 'moment';



const PreviewBlog = () => {
    const blogPreData = JSON.parse(localStorage.getItem('blogPreviewData') || '{}');
    const [blogData, setBlogData] = useState<any>([]);

    const date = moment(blogData.createdAt);
    const formattedDate = date.fromNow();

    useEffect(() => {
        setBlogData(blogPreData)
    }, [])


    return (
        <>
            <div className='blogs-heading-container'>
                <div className='category-readtime-box'>
                    {
                        blogData?.category?.map((item, index) => (
                            <div className='tags-box' key={index}>
                                <span className='po-caption'>{item.label}</span>
                            </div>
                        ))
                    }

                    <span className="line"></span>
                    <span className='blog-body-2'>{blogData.readingTime} mins read</span>
                    <span className="line"></span>
                    <span className='blog-body-2'>{formattedDate}</span>

                </div>
                <div>
                    <h2 className='blog-tittle'>{blogData?.title}</h2>
                </div>
                {/* <div className='share-button'><img src={share} alt="" /><p>Share</p></div> */}
            </div>

            <div className='detailPage-container'>
                <div className="blog-details">
                    <div className='img-div'>
                        <img src={blogData.image} alt="img" />
                    </div>
                    <div className='body-2' id='blogdata' dangerouslySetInnerHTML={{ __html: blogData.content || '' }}>
                    </div>
                    <div className="tag-box">
                        <h3 className='subtitle-3'>Related Tags:</h3>
                        {
                            blogData?.phrases?.slice(0, 6)?.map((item, index) => (
                                <div className='tags-box' key={index}>
                                    <span className='po-caption'>{item}</span>
                                </div>
                            ))
                        }


                    </div>
                </div>

            </div>
        </>
    )
}

export default PreviewBlog